const SESSION_KEY = "steam-admin-session";
const USERNAME_KEY = "steam-admin-username";

export function getAdminSession() {
  return sessionStorage.getItem(SESSION_KEY) || "";
}

export function getAdminUsername() {
  return sessionStorage.getItem(USERNAME_KEY) || "";
}

export function getApiBase() {
  return (import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/$/, "");
}

export function clearAdminSession() {
  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(USERNAME_KEY);
}

export async function loginAdmin(username: string, password: string) {
  const response = await fetch(`${getApiBase()}/admin/auth/login`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ username: username.trim(), password })
  });
  const payload = await response.json().catch(() => null) as {
    token?: string;
    username?: string;
    message?: string | string[];
  } | null;
  if (!response.ok || !payload?.token) {
    const message = Array.isArray(payload?.message) ? payload.message[0] : payload?.message;
    throw new Error(message || `登录失败（${response.status}）`);
  }
  sessionStorage.setItem(SESSION_KEY, payload.token);
  sessionStorage.setItem(USERNAME_KEY, payload.username || username.trim());
  return payload;
}

export async function adminRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${getApiBase()}${path}`, {
    ...init,
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${getAdminSession()}`,
      ...(init.headers || {})
    }
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    if (response.status === 401) {
      clearAdminSession();
      window.dispatchEvent(new Event("admin-auth-expired"));
    }
    const message = Array.isArray(payload?.message) ? payload.message[0] : payload?.message;
    throw new Error(message || `请求失败（${response.status}）`);
  }
  return response.json() as Promise<T>;
}
